<template>
    <uw-page title="合同描述">
        <template slot="header-suffix">
            <el-button type="primary" @click="$refs.drawerUpdate.Open({ id: contract.id, describe: contract.describe })">修改描述</el-button>
        </template>
        <froala-views v-model="contract.describe" />
        <crm-contract-update-describe ref="drawerUpdate" @onChange="TableSearch" />
    </uw-page>
</template>
<script>
export default {
    props: [ 'contract_id' ],
    data() {
        return {
            contract: {}
        }
    },
    watch: {
        contract_id: {
            handler(val) {
                if(val) {
                    this.TableSearch()
                }
            },
            immediate: true
        }
    },
    methods: {
        TableSearch() {
            this.$http.post('/9api/crm/contract/search-first', { id: this.contract_id }).then(async rps => {
                this.contract = rps.data
            })
        },
    }
}
</script>
